exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-required-field-form-loader[data-v-40f94b1a] {\n  position: absolute;\n  top: 50%;\n  left: 25%;\n}\n.loader-background-form[data-v-40f94b1a] {\n  opacity: .2;\n}\n", ""]);

// exports
